<template>
	<v-card elevation='0'  class="mx-auto">
		<v-card-text>
			<v-row dense>
				<v-spacer></v-spacer>
				<InstrucaoForm 
					v-if="$store.globalStore.getters.isAdmin && contextoIsSelected &&
							computedContextoSelecionado.get_configuracao.instrucoes_reserva"
					:instrucao="computedContextoSelecionado.get_configuracao"/>
			</v-row>

			<div v-if="contextoIsSelected && computedContextoSelecionado.get_configuracao.id" v-html="computedContextoSelecionado.get_configuracao.instrucoes_reserva"></div>
			
				<div class="text-center" v-show="contextoIsSelected">
					<Links/>
				</div>
		</v-card-text>
	</v-card>
</template>

<script>

import Links from '@/components/Links.vue'
import InstrucaoForm from '@/components/InstrucaoForm.vue'

export default {
	name: 'InstrucoesReserva',
	components:{
		Links, InstrucaoForm
	},
	computed:{
		computedContextoSelecionado(){
            return this.$store.globalStore.getters.getContexto
        },
		contextoIsSelected(){
            return this.computedContextoSelecionado && this.computedContextoSelecionado.id
        }
	}
}
</script>